import { render, staticRenderFns } from "./ListDisplayLoader.vue?vue&type=template&id=63870078&scoped=true"
import script from "./ListDisplayLoader.vue?vue&type=script&lang=ts"
export * from "./ListDisplayLoader.vue?vue&type=script&lang=ts"
import style0 from "./ListDisplayLoader.vue?vue&type=style&index=0&id=63870078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63870078",
  null
  
)

export default component.exports